export default __webpack_public_path__ + "static/media/raya-promo.f3ad790f.webp";